import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { v4 as uuid } from 'uuid';
import agent from '../api/agent';
import { TemplateSubTasks } from '../models/template';
import { store } from './store';

interface apiInput {
  apiUrlInput: string;
  apiBody: string;
  getApiInitScheme: any;
  apiMethod: string;
  apiModel: string;
  addNewApiTab: any;
  isExternalAPI: string;
}

export default class ApiStore {
  apiInput: apiInput = {
    apiUrlInput: '',
    apiBody: '',
    getApiInitScheme: [], //final post to the api
    apiMethod: '',
    apiModel: '',
    addNewApiTab: [],
    isExternalAPI: '',
  };
  getFetchData: any = [];
  loadingInitial = false;
  loading = false;
  isAddNewStatusTab = false;
  selectedMetadataElement: any = [];
  selectedAssetIdElement: any = [];
  validationstatus: string = '';
  statusActiveIndex: number = 0;
  templateMetadataElement: { key: string; value: string; text: string }[] = [];
  subtaskToken: string = '';

  // Get input values from the Api configuration component
  // setapiUrlInput = (data:string) => {
  //     this.apiInput.apiUrlInput = data;
  // }

  getApiMethod = (data: string) => {
    this.apiInput.apiMethod = data;
  };

  getApiExternal = (data: string, ind: boolean) => {
    this.apiInput.isExternalAPI = data + '|' + ind;
  };

  getapiBody = (data: string, ind: number) => {
    this.apiInput.apiBody = data + '|' + ind;
  };

  getApiSub = (data: string, ind: number) => {
    this.apiInput.apiUrlInput = data + '|' + ind;
  };

  // Set dummy template for all status of Api in initial time
  setApiScheme = (selected: any) => {
    let actionStatus = 0;
    switch (selected) {
      case 'Start':
        actionStatus = 1;
        break;
      case 'Complete':
        actionStatus = 2;
        break;
      case 'Hold':
        actionStatus = 3;
        break;
      case 'Resume':
        actionStatus = 4;
        break;
      case 'Reject':
        actionStatus = 5;
        break;
      case 'Rework':
        actionStatus = 6;
        break;
      case 'Resolve':
        actionStatus = 7;
        break;
      case 'V1':
        actionStatus = 8;
        break;
      case 'V2':
        actionStatus = 8;
        break;
      case 'V3':
        actionStatus = 8;
        break;
    }

    if (actionStatus !== 0) {
      const tabInitContent = '';
      const apiScheme = {
        id: uuid(),
        method: this.apiInput.apiMethod !== '' ? this.apiInput.apiMethod : '',
        url: '',
        isExternalAPI: false,
        body: tabInitContent,
        model: this.apiInput.apiModel !== '' ? this.apiInput.apiModel : '',
        urlmodel: '',
        data: '',
        token: '',
        status: actionStatus,
      };
      this.apiInput.getApiInitScheme = [
        ...this.apiInput.getApiInitScheme,
        apiScheme,
      ];
      this.apiInput.addNewApiTab = [apiScheme];
    }
  };
  //End

  constructor() {
    makeAutoObservable(this);
  }

  postApi = async (apiData: any) => {
    try {
      await agent.apiSetting.create(apiData);
      runInAction(() => {});
    } catch (error) {
      toast.error('API configuration settings failed');
    }
  };

  putApi = async (apiData: any) => {
    try {
      const resp: any = await agent.apiSetting.update(apiData);
      runInAction(() => {
        if (resp.data.isSuccess === false) {
          toast.error(resp.data.error);
        } else {
          toast.success('API configuration updated successfully');
        }
      });
    } catch (error: any) {
      toast.error('Pls Try Again !');
    }
  };

  deleteApi = async (delComId: any, data: any) => {
    try {
      await agent.apiSetting.delApiSetting(delComId);
      runInAction(() => {
        this.apiInput.getApiInitScheme = data;
        toast.info('API Configuration deleted successfully');
      });
    } catch (error: any) {
      toast.error('Pls Try Again !');
    }
  };
  getAnyApiMethod = async (url: string) => {
    this.selectedMetadataElement = [];
    try {
      const response = await agent.apiSetting.getAnyApi(url);

      runInAction(() => {
        const ArrayBool = Array.isArray(response);

        if (ArrayBool) {
          this.getFetchData = response;
        } else {
          this.getFetchData.push(response);
        }

        toast.success('Fetched Data SuccessFully');
        this.getElementandMetaData();
      });
    } catch (error: any) {
      toast.error('Pls Try Again !');
    }
  };
  getElementandMetaData = async () => {
    await store.metaDataStore
      .loadMetaDataETById(store.TemplateStore?.selectedElementTypes!?.id)
      .then(
        (json) =>
          json?.metadata.forEach((x) => {
            if (
              x.elementType !== 'Barcode' &&
              x.elementType !== 'Dynamicmetadata' &&
              x.elementType !== 'AddFiles' &&
              x.elementType !== 'AddPhotograph'
            ) {
              this.selectedMetadataElement.push({
                text: x.elementName,
                value: x.elementId,
                key: x.elementId,
              });
            }
          }),
      );

    await store.TemplateStore.loadSubTaskById(
      store?.TemplateStore?.selectedSubTasks!?.subTaskId,
    ).then(
      (json) =>
        json?.elements.forEach((x) => {
          if (
            x.elementType !== 'Barcode' &&
            x.elementType !== 'Dynamicmetadata' &&
            x.elementType !== 'AddFiles' &&
            x.elementType !== 'AddPhotograph'
          ) {
            this.selectedMetadataElement.push({
              text: x.elementName,
              value: x.elementId,
              key: x.elementId,
            });
          }
        }),
    );
    return this.selectedMetadataElement;
  };

  statusActiveindexes = (index: number) => {
    this.statusActiveIndex = index;
  };

  DynamicAssetId = async (id: string) => {
    try {
      const AssetId = await agent.apiSetting.assetId(id);

      runInAction(() => {
        if (AssetId.data !== undefined) {
          this.selectedAssetIdElement = AssetId.data;
          this.metadataGetApi(this.selectedAssetIdElement?.element_Id);
        }
      });
    } catch {
      toast.error('Something went wrong !');
    }
  };
  validationViewasset = async (
    itemId: string,
    templateId: string,
    subtaskId: string,
    element: TemplateSubTasks,
  ) => {
    try {
      const data1 = await agent.apiSetting.viewassetpage(
        itemId,
        templateId,
        subtaskId,
        element,
      );

      this.validationstatus = data1.data;
    } catch (error) {
      console.log(error);
    }
  };

  metadataGetApi = async (id: string) => {
    try {
      this.templateMetadataElement.length = 0;
      await agent.MetaDataElementType.listMetaDataETDetails(id).then(
        (json) =>
          json?.metadata.forEach((x: any) => {
            this.templateMetadataElement.push({
              text: x.elementName,
              value: x.elementId,
              key: x.elementId,
            });
          }),
      );
      return (this.templateMetadataElement =
        this.templateMetadataElement.filter(
          (ele, ind) =>
            ind ===
            this.templateMetadataElement.findIndex(
              (elem) => elem.key === ele.key && elem.text === ele.text,
            ),
        ));
    } catch {
      toast.error('Unable to fetch components');
    }
  };

  subtasktokendata = (id: string) => {
    this.subtaskToken = id;
  };
}
